<template>
  <page-stepped
    ref="page"
    :title="title"
    :steps="steps"
    :model="model"
    :fetch-endpoint="null"
    :save-endpoint="saveEndpoint"
    :after-save="afterSave"
    :rules="rules"
    :breadcrumbs="breadcrumbs"
    :icon="icon"
    :description="description"
  />
</template>

<script>
import PageStepped from '@/common/components/page/IntegrationCreatePageStepped'
import Integrations from '@/modules/integrations/types'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import { EventBus } from '@/core/EventBus'

export default {
  name: 'IntegrationCreateSteppedPage',

  components: {
    PageStepped
  },
  data() {
    return {
      currentStepIndex: 0,
      model: {
        type: this.$route.query.type,
        project_id: this.$route.query.project_id,
        name: this.$t(Integrations[this.$route.query.type].title),
        params: {},
        source: {},
        config: {},
        active: 1
      }
    }
  },
  mounted() {
    Integrations[this.$route.query.type].steps.reduce((obj, step) => {
      if (step.hasOwnProperty('rules')) {
        this.applyTranslations(step.rules)
      }
      return Object.assign(obj, step.rules)
    }, {})
    EventBus.$on('active-step', event => {
      this.currentStepIndex = event.index
    })
  },
  computed: {
    title() {
      return (
        this.$t('Integrations_Text_Connect') +
        ' ' +
        this.$t(Integrations[this.$route.query.type].title)
      )
    },

    steps() {
      return Integrations[this.$route.query.type].steps.map((item, index) => {
        item.title = this.$t(item.title)
        return item
      })
    },

    rules() {
      return Integrations[this.$route.query.type].steps[this.currentStepIndex]
        .rules
    },

    icon() {
      return Integrations[this.$route.query.type].image
    },

    description() {
      return this.$t(Integrations[this.$route.query.type].description)
    },

    saveEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `integrations`
      })
    },

    breadcrumbs() {
      return [
        {
          label: this.$t('Integrations_Breadcrumb_Settings')
        },
        {
          label: this.$t('Integrations_Breadcrumb_Integrations'),
          route: projectRoute({
            name: 'IntegrationsMarketplace'
          })
        },
        {
          label: this.$t('Integrations_Breadcrumb_ConnectNew')
        }
      ]
    }
  },
  methods: {
    afterSave(model) {
      this.$router.push(this.redirectRoute(model))
    },

    redirectRoute(model) {
      return projectRoute({
        name: 'IntegrationOverview',
        query: { id: model.id }
      })
    },
    applyTranslations(obj) {
      if (typeof obj === 'object') {
        for (var keys in obj) {
          if (typeof obj[keys] === 'object') {
            this.applyTranslations(obj[keys])
          } else {
            if (keys === 'message') {
              let keyValue = this.$t(obj[keys])
              obj[keys] = keyValue
            }
          }
        }
      }
      return obj
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/pages/IntegrationCreateSteppedPage.vue